import Vue from 'vue'
import VueRouter from 'vue-router'
import pclogin from '../views/pcLogin'
import mobilelogin from '../views/mobileLogin'
import bindtel from '../views/bindTel'
import boundtel from '../views/boundTel'
import handleLogin from "../views/handleLogin";
import callback from "../views/callback";
import loginout from "../views/loginout";
import pcpage from "../views/pcpage";
import pcheader from "../views/pc_header";
import pcbind from "../views/pc_bind";
import information from "../views/information";

Vue.use(VueRouter)

const routes = [
  // H5测试页
  {
    path:'/loginout',
    name:'loginout',
    component:loginout
  },
  // PC测试页
  {
    path:'/pcpage',
    name:'pcpage',
    component:pcpage
  },
  // PC头部导航
  {
    path:'/pcheader',
    name:'pc_header',
    component:pcheader
  },
  // PC登录
  {
    path: '/pclogin',
    name: 'pcLogin',
    component: pclogin
  },
  // PC绑定手机号
  {
    path:'/pcbind',
    name:'pcbind',
    component:pcbind
  },
  // 移动端登录
  {
    path: '/mobilelogin',
    name: 'mobileLogin',
    component: mobilelogin
  },
  // 移动端绑定手机号
  {
    path: '/bindtel',
    name: 'bindtel',
    component: bindtel
  },
  // 手机号已被绑定
  {
    path:'/boundtel',
    name:'boundtel',
    component:boundtel
  },
  // 统一处理第三方登录
  {
    path: '/handlelogin',
    name: 'handlelogin',
    component: handleLogin
  },
  // 三方回调域
  {
    path: '/callback',
    name: 'callback',
    component: callback
  },
  // 账号确认
  {
    path:'/information',
    name:'information',
    component:information
  }
]

const router = new VueRouter({
  mode: 'history',
  base: 'publicmodule',
  routes
})

export default router